import Container from 'react-bootstrap/Container';
import Logo from '../components/svg/Logo';

export default function Header() {
  return (
    <Container as="header" className="py-2 py-md-3">
      <Logo />
    </Container>
  );
}